import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import imageFallback from 'loyal-design-system/assets/images/products/product_placeholder.png'

const CardImage = ({ linkTo, altText, imageUrl, visibleByDefault }) => (
  <div className='card-img col-12 row txt-center py-3 t-1'>
    <div className='row col-12 ml-auto mr-auto t-0 pos-absolute'>
      <div className='col-12 m-0 p-0'>
        <Link to={linkTo} aria-label={altText}>
          <img
            alt={altText}
            placeholderSrc={imageFallback}
            className='card-image-fallback'
            src={imageUrl} />
        </Link>
      </div>
    </div>
  </div>
)

CardImage.propTypes = {
  linkTo: PropTypes.string.isRequired,
  altText: PropTypes.string,
  imageUrl: PropTypes.string,
  visibleByDefault: PropTypes.bool
}

export default memo(CardImage)



// WEBPACK FOOTER //
// ./src/features/Availability/ProductCard/CardImage/index.js